export const routing: { [key: string]: { [key: string]: string } } = {
  PL: {
    contact: '/kontakt',
    terms: '/regulamin',
    cookies: '/polityka-cookies',
    cookiesTable: '/tabela-cookies',
    article: '/artykul',
    articles: '/artykuly',
    preview: '/podglad/artykul',
  },
  DE: {
    contact: '/kontakt',
    terms: '/satzung',
    cookies: '/cookies-politik',
    cookiesTable: '/tabelle-der-cookies',
    article: '/artikel',
    articles: '/artikel',
    preview: '/vorschau/artikel',
  },
  EN: {
    contact: '/contact',
    terms: '/terms',
    cookies: '/cookie-policy',
    cookiesTable: '/cookie-table',
    article: '/article',
    articles: '/articles',
    preview: '/preview/article',
  },
  CZ: {
    contact: '/kontakt',
    terms: '/pravidla',
    cookies: '/cookies',
    cookiesTable: '/tabulka-cookies',
    article: '/clanek',
    articles: '/clanky',
    preview: '/nahled/clanek',
  },
};

export const common: { [key: string]: { [key: string]: string } } = {
  PL: {
    readMore: 'Czytaj więcej',
    noArticles: 'Brak artykułów w serwisie',
    labelArticleSponsored: 'Artykuł sponsorowany',
    sectionArticlesLatest: 'Artykuły ostatnio dodane',
    sectionCategoriesHome: 'Artykuły według kategorii',
    sectionCategoriesSide: 'Kategorie artykułów',
    sectionArticlesRecommended: 'Polecane artykuły',
    sectionArticles: 'Artykuły',
    sectionArticlesByCategory: 'Artykuły z kategorii',
    sectionCookieTable: 'Tabela Cookies',
    error: 'Błąd 404 strony nie znaleziono',
    tableOfContentsTitle: 'Spis treści',
  },
  DE: {
    readMore: 'Meer lezen',
    noArticles: 'Geen artikelen op de site',
    labelArticleSponsored: 'Gesponsord artikel',
    sectionArticlesLatest: 'Neueste Artikel',
    sectionCategoriesHome: 'Artikel per categorie',
    sectionCategoriesSide: 'Artikelkategorien',
    sectionArticlesRecommended: 'Empfohlene Artikel',
    sectionArticles: 'Artikel',
    sectionArticlesByCategory: 'Categorie artikelen',
    sectionCookieTable: 'Tabelle der Cookies',
    error: 'Fehler 404 Seite nicht gefunden',
    tableOfContentsTitle: 'Inhalt',
  },
  EN: {
    readMore: 'Read more',
    noArticles: 'No articles',
    labelArticleSponsored: 'Sponsored article',
    sectionArticlesLatest: 'Latest articles',
    sectionCategoriesHome: 'Article categories',
    sectionCategoriesSide: 'Article categories',
    sectionArticlesRecommended: 'You might be interested',
    sectionArticles: 'Articles',
    sectionArticlesByCategory: 'Article categories',
    sectionCookieTable: 'Cookie table',
    error: 'Error 404 page not found',
    tableOfContentsTitle: 'Table of contents',
  },
  CZ: {
    readMore: 'Číst více',
    noArticles: 'Žádné články',
    labelArticleSponsored: 'Sponzorovaný článek',
    sectionArticlesLatest: 'Poslední články',
    sectionCategoriesHome: 'Kategorie článků',
    sectionCategoriesSide: 'Kategorie článků',
    sectionArticlesRecommended: 'Doporučené články',
    sectionArticles: 'Články',
    sectionArticlesByCategory: 'Kategorie článků',
    sectionCookieTable: 'Tabulka cookies',
    error: 'Chyba 404 - stránka nenalezena',
    tableOfContentsTitle: 'Obsah',
  },
};

export const breadcrumbs: { [key: string]: { [key: string]: string } } = {
  PL: {
    home: 'Strona główna',
    articles: 'Artykuły',
    contact: 'Kontakt',
    regulations: 'Regulamin',
    cookie: 'Polityka cookies',
    cookieTable: 'Tabela Cookies',
  },
  DE: {
    home: 'Hauptseite',
    articles: 'Artikel',
    contact: 'Kontakt',
    regulations: 'Satzung',
    cookie: 'Cookies politik',
    cookieTable: 'Tabelle der Cookies',
  },
  EN: {
    home: 'Main page',
    articles: 'Articles',
    contact: 'Contact',
    regulations: 'Terms of service',
    cookie: 'Cookies',
    cookieTable: 'Cookie table',
  },
  CZ: {
    home: 'Hlavní stránka',
    articles: 'Články',
    contact: 'Kontakt',
    regulations: 'Podmínky služby',
    cookie: 'Cookies',
    cookieTable: 'Tabulka cookies',
  },
};

export const header: { [key: string]: { [key: string]: string } } = {
  PL: {
    article: 'Artykuły',
    contact: 'Kontakt',
  },
  DE: {
    article: 'Artikel',
    contact: 'Kontakt',
  },
  EN: {
    article: 'Articles',
    contact: 'Contact',
  },
  CZ: {
    article: 'Články',
    contact: 'Kontakt',
  },
};

export const footer: { [key: string]: { [key: string]: string } } = {
  PL: {
    copyright: 'wszelkie prawa zastrzeżone',
    home: 'Strona główna',
    articles: 'Artykuły',
    regulations: 'Regulamin',
    cookiePolicy: 'Polityka cookies',
    contact: 'Kontakt',
  },
  DE: {
    copyright: 'alle rechten voorbehouden',
    home: 'Hauptseite',
    articles: 'Artikel',
    regulations: 'Satzung',
    cookiePolicy: 'Cookies politik',
    contact: 'Kontakt',
  },
  EN: {
    copyright: 'all rights reserved',
    home: 'Main page',
    articles: 'Articles',
    regulations: 'Terms of service',
    cookiePolicy: 'Cookies',
    contact: 'Contact',
  },
  CZ: {
    copyright: 'všechna práva vyhrazena',
    home: 'Hlavní stránka',
    articles: 'Články',
    regulations: 'Podmínky služby',
    cookiePolicy: 'Cookies',
    contact: 'Kontakt',
  },
};

export const cookies: { [key: string]: { [key: string]: string } } = {
  PL: {
    popupHeader: 'Dbamy o Twoją prywatność',
    popupParagraphFirst: 'Korzystamy z plików cookies, które zapisują się w pamięci Twojej przeglądarki.',
    popupParagraphSecond:
      'Dzięki nim zapewniamy prawidłowe działanie strony. Korzystamy z nich także w celach analitycznych i reklamowych, również przy współpracy z partnerami. Możesz zarządzać plikami cookies przechodząc do ustawień. Więcej informacji znajdziesz w naszej <a href="/polityka-cookies/">Polityce Cookies</a>.',
    popupSettings: 'Ustawienia',
    popupReject: 'Nie zgadzam się',
    popupAccept: 'Akceptuję wszystkie',
    configHeader: 'Zaawansowane ustawienia cookies',
    configCheckBox: 'Włączony',
    configEssentialHeader: 'Niezbędne pliki cookies',
    configEssentialContent:
      'Techniczne i funkcjonalne pliki cookie umożliwiają prawidłowe działanie naszej strony internetowej. Wykorzystujemy je w celu zapewnienia bezpieczeństwa i odpowiedniego wyświetlania strony. Dzięki nim możemy ulepszyć usługi oferowane za jej pośrednictwem, na przykład dostosowując je do wyborów użytkownika. Pliki z tej kategorii umożliwiają także rozpoznanie preferencji użytkownika po powrocie na naszą stronę.',
    configAnalyticalHeader: 'Analityczne pliki cookies',
    configAnalyticalContent:
      'Analityczne pliki cookie zbierają informacje na temat liczby wizyt użytkowników i ich aktywności na naszej stronie internetowej. Dzięki nim możemy mierzyć i poprawiać wydajność naszej strony. Pozwalają nam zobaczyć, w jaki sposób odwiedzający poruszają się po niej i jakimi informacjami są zainteresowani. Dzięki temu możemy lepiej dopasować stronę internetową do potrzeb użytkowników oraz rozwijać naszą ofertę. Wszystkie dane są zbierane i agregowane anonimowo.',
    configMarketingHeader: 'Marketingowe pliki cookies',
    configMarketingContent:
      'Marketingowe pliki cookie są wykorzystywane do dostarczania reklam dopasowanych do preferencji użytkownika. Mogą być ustawiane przez nas lub naszych partnerów reklamowych za pośrednictwem naszej strony. Umożliwiają rozpoznanie zainteresowań użytkownika oraz wyświetlanie odpowiednich reklam zarówno na naszej stronie, jak i na innych stronach internetowych i platformach społecznościowych. Pliki z tej kategorii pozwalają także na mierzenie skuteczności kampanii marketingowych.',
    configSave: 'Zapisz ustawienia',
    configAcceptAll: 'Zezwól na wszystkie pliki cookies',
  },
  DE: {
    popupHeader: 'Wir kümmern uns um Ihre Privatsphäre',
    popupParagraphFirst: 'Wir verwenden Cookies, die im Speicher Ihres Browsers gespeichert werden.',
    popupParagraphSecond:
      'Dank ihnen stellen wir das ordnungsgemäße Funktionieren der Website sicher. Wir nutzen sie auch zu Analyse- und Werbezwecken, auch in Zusammenarbeit mit Partnern. Sie können Cookies verwalten, indem Sie zu den Einstellungen gehen. Weitere Informationen finden Sie in unserer <a href="/cookies-politik/">Cookie-Richtlinie</a>.',
    popupSettings: 'Einstellungen',
    popupReject: 'Ich bin dagegen',
    popupAccept: 'Akzeptiere alles',
    configHeader: 'Erweiterte Cookie-Einstellungen',
    configCheckBox: 'Ingeschakeld',
    configEssentialHeader: 'Unverzichtbare Cookies',
    configEssentialContent:
      'Technische und funktionale Cookies ermöglichen das ordnungsgemäße Funktionieren unserer Website. Wir verwenden sie, um die Sicherheit zu gewährleisten und die korrekte Anzeige der Website sicherzustellen. Mit ihrer Hilfe können wir die über die Website angebotenen Dienste verbessern, indem wir sie an die Vorlieben des Nutzers anpassen. Diese Cookies ermöglichen es uns auch, die Präferenzen des Nutzers bei seiner Rückkehr auf unsere Website zu erkennen.',
    configAnalyticalHeader: 'Analytische Cookies',
    configAnalyticalContent:
      'Analytische Cookies sammeln Informationen über die Anzahl der Besuche der Nutzer und deren Aktivitäten auf unserer Website. Mit ihrer Hilfe können wir die Leistung unserer Website messen und verbessern. Sie ermöglichen es uns, zu sehen, wie sich die Besucher auf der Website bewegen und an welchen Informationen sie interessiert sind. Dies hilft uns, die Website besser an die Bedürfnisse der Nutzer anzupassen und unser Angebot weiterzuentwickeln. Alle Daten werden anonym gesammelt und aggregiert.',
    configMarketingHeader: 'Marketing-Cookies',
    configMarketingContent:
      'Marketing-Cookies werden verwendet, um Werbung zu liefern, die den Präferenzen des Nutzers entspricht. Sie können von uns oder unseren Werbepartnern über unsere Website gesetzt werden. Sie ermöglichen es, die Interessen des Nutzers zu erkennen und entsprechende Werbung sowohl auf unserer Website als auch auf anderen Websites und sozialen Plattformen anzuzeigen. Diese Cookies ermöglichen es auch, die Wirksamkeit von Marketingkampagnen zu messen.',
    configSave: 'Speichern einstellungen',
    configAcceptAll: 'Alle Cookies zulassen',
  },
  EN: {
    popupHeader: 'We care about your privacy',
    popupParagraphFirst: "We use cookies that are saved in your browser's memory.",
    popupParagraphSecond:
      'They help us ensure the proper functioning of the website. We also use them for analytical and advertising purposes, including in cooperation with partners. You can manage cookies by going to settings. More information can be found in our <a href="/cookie-policy/">Cookie Policy</a>.',
    popupSettings: 'Settings',
    popupReject: 'I disagree',
    popupAccept: 'Accept all',
    configHeader: 'Advanced cookie configuration',
    configCheckBox: 'Enabled',
    configEssentialHeader: 'Required cookies',
    configEssentialContent:
      "Technical and functional cookies enable the proper functioning of our website. We use them to ensure security and correct display of the website. With their help, we can improve the services offered through the website by adapting them to the user's preferences. These cookies also allow us to recognize the user's preferences when they return to our website.",
    configAnalyticalHeader: 'Analytical cookies',
    configAnalyticalContent:
      "Analytical cookies collect information about the number of user visits and their activities on our website. With their help, we can measure and improve the performance of our website. They allow us to see how visitors move around the website and what information they are interested in. This helps us better adapt the website to users' needs and develop our offer. All data is collected anonymously and aggregated.",
    configMarketingHeader: 'Marketing cookies',
    configMarketingContent:
      "Marketing cookies are used to deliver advertising that matches the user's preferences. They may be set by us or our advertising partners through our website. They allow recognizing the user's interests and displaying relevant advertising both on our website and on other websites and social platforms. These cookies also allow measuring the effectiveness of marketing campaigns.",
    configSave: 'Save configuration',
    configAcceptAll: 'Allow all cookies',
  },
  CZ: {
    popupHeader: 'Záleží nám na vašem soukromí',
    popupParagraphFirst: 'Používáme cookies, které se ukládají do paměti vašeho prohlížeče.',
    popupParagraphSecond:
      'Díky nim zajišťujeme správné fungování webu. Využíváme je také pro analytické a reklamní účely, a to i ve spolupráci s partnery. Soubory cookie můžete spravovat v nastavení. Další informace naleznete v našich zásadách používání <a href="/cookies/">Souborů cookie</a>.',
    popupSettings: 'Nastavení',
    popupReject: 'Nesouhlasím',
    popupAccept: 'Přijmout vše',
    configHeader: 'Pokročilá konfigurace cookies',
    configCheckBox: 'Povoleno',
    configEssentialHeader: 'Technické a funkční cookies',
    configEssentialContent:
      'Technické a funkční cookies umožňují správné fungování našich webových stránek. Používáme je k zajištění bezpečnosti a správného zobrazení webových stránek. S jejich pomocí můžeme zlepšovat služby nabízené prostřednictvím webových stránek jejich přizpůsobením preferencím uživatele. Tyto cookies nám také umožňují rozpoznat preference uživatele, když se vrátí na naše webové stránky.',
    configAnalyticalHeader: 'Analytické cookies',
    configAnalyticalContent:
      'Analytické cookies shromažďují informace o počtu návštěv uživatelů a jejich aktivitách na našich webových stránkách. S jejich pomocí můžeme měřit a zlepšovat výkon našich webových stránek. Umožňují nám vidět, jak se návštěvníci pohybují po webových stránkách a o jaké informace se zajímají. To nám pomáhá lépe přizpůsobit webové stránky potřebám uživatelů a rozvíjet naši nabídku. Všechna data jsou shromažďována anonymně a agregována.',
    configMarketingHeader: 'Marketingové cookies',
    configMarketingContent:
      'Marketingové cookies se používají k doručování reklamy, která odpovídá preferencím uživatele. Mohou být nastaveny námi nebo našimi reklamními partnery prostřednictvím našich webových stránek. Umožňují rozpoznat zájmy uživatele a zobrazovat relevantní reklamu jak na našich webových stránkách, tak na jiných webových stránkách a sociálních platformách. Tyto cookies také umožňují měřit efektivitu marketingových kampaní.',
    configSave: 'Uložit nastavení',
    configAcceptAll: 'Povolit všechny cookies',
  },
};

export const contact: { [key: string]: { [key: string]: string } } = {
  PL: {
    header: 'Kontakt',
    fieldCompanyName: 'Nazwa firmy',
    fieldCity: 'Miejscowość',
    fieldNip: 'NIP',
    fieldPhone: 'Telefon',
    fieldEmail: 'E-mail',
    fieldName: 'Imię i nazwisko',
    fieldContent: 'Opisz powód kontaktu',
    fieldContentPlaceholder: 'od 20 do 1000 znaków',
    fieldContentMessage: 'pozostała liczba znaków',
    fieldCaptcha: 'Wpisz znaki z obrazka',
    checkBoxFirst:
      'Akceptuję <a href="/regulamin/">Regulamin</a> i wyrażam zgodę na przetwarzanie przez Wenet Group S.A. i WeNet Sp. z o.o. udostępnionych przeze mnie danych osobowych na zasadach opisanych w <a href="/regulamin/">Regulaminie</a> serwisu. Oświadczam, że są mi znane cele przetwarzania danych osobowych oraz moje uprawnienia w tym zakresie.',
    checkBoxSecond:
      'Wyrażam zgodę na wykonywanie przez Wenet Group S.A. i WeNet Sp. z o.o. działań w zakresie marketingu bezpośredniego kierowanych na urządzenia telekomunikacyjne, w tym w szczególności telefony lub komputery, których jestem użytkownikiem końcowym oraz wyrażam zgodę na otrzymywanie od Wenet Group S.A. i WeNet Sp. z o.o. informacji handlowych za pomocą środków komunikacji elektronicznej, także przy użyciu automatycznych systemów wywołujących na podane w niniejszym formularzu: adres poczty elektronicznej lub numer telefonu. Przyjmuję do wiadomości, że zgoda udzielona Wenet Group S.A. i WeNet Sp. z o.o. w zakresie wyżej wymienionej komunikacji marketingowej może być przeze mnie wycofana w dowolnym czasie, poprzez kontakt z Działem Obsługi Klienta tel. 22 457 30 95 lub email <a href="mailto:seo.zap@wenet.pl">seo.zap@wenet.pl</a>, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem.',
    submit: 'Wyślij formularz',
    messageSuccessHead: 'Twoja wiadomość została wysłana',
    messageSuccessDesc: 'Dziękujemy za korespondencję',
    messageError: 'Błąd - akcja została wstrzymana',
  },
  DE: {
    header: 'Kontakt',
    fieldCompanyName: 'Firmenname',
    fieldCity: 'Stadt',
    fieldNip: 'NIP',
    fieldPhone: 'Telefon',
    fieldEmail: 'E-Mail',
    fieldName: 'Vor- und Nachname',
    fieldContent: 'Beschreiben Sie den Grund für die Kontaktaufnahme',
    fieldContentPlaceholder: 'zwischen 20 und 1000 Zeichen',
    fieldContentMessage: 'verbleibende Anzahl von Zeichen',
    fieldCaptcha: 'Geben Sie Zeichen aus dem Bild ein',
    checkBoxFirst:
      'Ich akzeptiere die <a href="/satzung/">Nutzungsbedingungen</a> und stimme der Verarbeitung meiner von mir bereitgestellten personenbezogenen Daten durch die Wenet Group S.A. und WeNet Sp. z o.o. zu den in den <a href="/satzung/">Nutzungsbedingungen</a> des Dienstes beschriebenen Bedingungen zu. Ich erkläre, dass mir die Zwecke der Verarbeitung personenbezogener Daten sowie meine diesbezüglichen Rechte bekannt sind.',
    checkBoxSecond:
      'Ich stimme zu, dass die Wenet Group S.A. und WeNet Sp. z o.o. Maßnahmen im Bereich des Direktmarketings an Telekommunikationsgeräten, insbesondere Telefonen oder Computern, die ich als Endnutzer verwende, durchführen und dass ich von der Wenet Group S.A. und WeNet Sp. z o.o. kommerzielle Informationen mittels elektronischer Kommunikationsmittel, auch unter Verwendung automatischer Anrufsysteme, an die in diesem Formular angegebene E-Mail-Adresse oder Telefonnummer erhalte. Ich nehme zur Kenntnis, dass die der Wenet Group S.A. und WeNet Sp. z o.o. erteilte Zustimmung bezüglich der oben genannten Marketingkommunikation jederzeit von mir widerrufen werden kann, indem ich den Kundenservice unter der Telefonnummer 22 457 30 95 oder per E-Mail unter <a href="mailto:seo.zap@wenet.pl">seo.zap@wenet.pl</a> kontaktiere, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung vor ihrem Widerruf erfolgten Verarbeitung berührt wird.',
    submit: 'Formular abschicken',
    messageSuccessHead: 'Ihre Nachricht wurde gesendet',
    messageSuccessDesc: 'Vielen Dank für Ihre Korrespondenz',
    messageError: 'Fehler - Aktion ausgesetzt',
  },
  EN: {
    header: 'Contact',
    fieldCompanyName: 'Company name',
    fieldCity: 'Locality',
    fieldNip: 'NIP',
    fieldPhone: 'Phone',
    fieldEmail: 'E-mail',
    fieldName: 'Name',
    fieldContent: 'Contact propose',
    fieldContentPlaceholder: 'from 20 to 1000 characters',
    fieldContentMessage: 'characters remain',
    fieldCaptcha: 'Enter the characters from the image',
    checkBoxFirst:
      'I accept the <a href="/terms/">Terms</a> of Use and consent to the processing of my personal data provided by me by Wenet Group S.A. and WeNet Sp. z o.o. under the conditions described in the <a href="/terms/">Terms</a> of Service. I declare that I am aware of the purposes of processing personal data and my rights in this regard.',
    checkBoxSecond:
      'I agree that Wenet Group S.A. and WeNet Sp. z o.o. may conduct direct marketing activities on telecommunication devices, in particular telephones or computers that I use as an end user, and that I may receive commercial information from Wenet Group S.A. and WeNet Sp. z o.o. by means of electronic communication, including using automatic calling systems, to the email address or telephone number provided in this form. I acknowledge that the consent given to Wenet Group S.A. and WeNet Sp. z o.o. regarding the above-mentioned marketing communications can be withdrawn by me at any time by contacting customer service at 22 457 30 95 or by email at <a href="mailto:seo.zap@wenet.pl">seo.zap@wenet.pl</a>, without affecting the lawfulness of processing based on consent before its withdrawal.',
    submit: 'Send form',
    messageSuccessHead: 'Your message has been sent',
    messageSuccessDesc: 'Thank you for your message',
    messageError: 'Error - the action has been paused',
  },
  CZ: {
    header: 'Kontakt',
    fieldCompanyName: 'Název společnosti',
    fieldCity: 'Lokalita',
    fieldNip: 'NIP',
    fieldPhone: 'Telefon',
    fieldEmail: 'E-mail',
    fieldName: 'Jméno',
    fieldContent: 'Účel kontaktu',
    fieldContentPlaceholder: 'od 20 do 1000 znaků',
    fieldContentMessage: 'zbývající znaky',
    fieldCaptcha: 'Zadejte znaky z obrázku',
    checkBoxFirst:
      'Souhlasím s <a href="/pravidla/">Podmínkami</a> použití a souhlasím se zpracováním mých osobních údajů poskytnutých mnou společností Wenet Group S.A. a WeNet Sp. z o.o. za podmínek popsaných v <a href="/pravidla/">Podmínkách</a> služby. Prohlašuji, že jsem si vědom/a účelů zpracování osobních údajů a svých práv v této souvislosti.',
    checkBoxSecond:
      'Souhlasím s tím, aby Wenet Group S.A. a WeNet Sp. z o.o. mohly provádět přímé marketingové aktivity na telekomunikačních zařízeních, zejména telefonech nebo počítačích, které používám jako koncový uživatel, a abych mohl/a dostávat obchodní informace od Wenet Group S.A. a WeNet Sp. z o.o. prostřednictvím elektronické komunikace, včetně používání automatických volacích systémů, na e-mailovou adresu nebo telefonní číslo uvedené v tomto formuláři. Beru na vědomí, že souhlas udělený společnosti Wenet Group S.A. a WeNet Sp. z o.o. týkající se výše uvedené marketingové komunikace mohu kdykoli odvolat kontaktováním zákaznického servisu na čísle 22 457 30 95 nebo e-mailem na adrese <a href="mailto:seo.zap@wenet.pl">seo.zap@wenet.pl</a>, aniž by to ovlivnilo zákonnost zpracování založeného na souhlasu před jeho odvoláním.',
    submit: 'Odeslat formulář',
    messageSuccessHead: 'Vaše zpráva byla odeslána',
    messageSuccessDesc: 'Děkujeme za vaši zprávu',
    messageError: 'Chyba - akce byla pozastavena',
  },
};
